exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SpiderWebChart {\n    flex-basis: 100%;\n    flex-grow: 1;\n    flex-shrink: 1\n}\n.SpiderWebChart .day-of-week.mon {\n    text-anchor: middle;\n}\n.SpiderWebChart .day-of-week.fri,\n\n        .SpiderWebChart .day-of-week.sat,\n\n        .SpiderWebChart .day-of-week.sun {\n    text-anchor: end;\n}", ""]);

// exports
